import React from "react";

const EquipmentMenu = ({
  // Module and Inverter Information
  mod, // Array representing module details
  inverter, // { type }

  // Proposal Details
  proposal, // { groundMount, maxOffset }

  // Panel Information
  panelAmount,
  maxModCount,
  totalProduction,
  totalUsage,

  // View State
  view, // Determines view logic

  // Callback Functions
  addPanel,
  removePanel,

  // Miscellaneous
  dash, // Image source for the "dash" button
  plus, // Image source for the "plus" button
}) => {
  return (
    <>
      <div className="container">
        <div className="row">
          <h3 className="menuFont">Equipment</h3>
        </div>
        <div className="custContainer menu">
          <div className="row">
            <div className="menuBorder"></div>
          </div>
          <div className="row">
            <div className="savingsText modals equip">
              Premium Tier 1 Panels - {mod[3]}W | {inverter.type} IQ
            </div>
          </div>
          <div className="panel-edit">
            <div className="modalContainer panel-count">
              {view === `1` ? (
                panelAmount === 7 || +proposal.groundMount === 1 ? (
                  <div className="panel-button">
                    <img src={dash} />
                  </div>
                ) : (
                  <div onClick={() => removePanel()} className="panel-button">
                    <img src={dash} />
                  </div>
                )
              ) : (
                <></>
              )}
            </div>
            <div className="savingsText modals big">{panelAmount} Panels</div>
            <div className="modalContainer panel-count">
              {view === `1` ? (
                panelAmount === +maxModCount ||
                (proposal.maxOffset &&
                  (totalProduction / totalUsage) * 100 >=
                    +proposal.maxOffset * 0.97) ||
                +proposal.groundMount === 1 ? (
                  <div className="panel-button">
                    <img src={plus} />
                  </div>
                ) : (
                  <div onClick={() => addPanel()} className="panel-button">
                    <img src={plus} />
                  </div>
                )
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EquipmentMenu;
